/*@ngInject*/
const ProductTemplateRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getProductTemplatesByFilterUri = function (filterUri, requestParams) {
        var url = '/rest/ProductTemplate/filter',
            config = {
                params: {
                    filterUri: filterUri,
                    sortBy: requestParams.key,
                    sortDirection: requestParams.sortType,
                    startIndex: requestParams.startIndex,
                    numberOfRows: requestParams.pageSize
                }
            };

            return this.get(url, config);
        };

};

angular.module('ums.configuration')
    .service('productTemplateRepository', ProductTemplateRepository);
